import { createContext } from 'react';

// consider getting rid from wrapper variant
var WrapperVariantContext = createContext(null);

export { WrapperVariantContext as W };
//# sourceMappingURL=WrapperVariantContext-747fba40.js.map
